// React imports.
import React from "react";


// App imports.
import Assessment1MainTableRow from "./Assessment1MainTableRow";

const Assessment1MainTable = ({ state, step, holder, fieldChangeHandler }) => (
  <div>
    <br />
    <div className="vendorsReportedGrid">
      <div className="header">Main Heating Fuel</div>
      {step.showComputedAverageExpenditure === true &&
        <div className="header">Average Annual Electric Bill from Performance Measures</div>
      }
      {step.showSedsElectricNonHeatExpenditure === true &&
        <div className="header">Estimated Average Annual Electric Bill Based on ACS</div>
      }
      {step.showPercentOfSedsString === true &&
        <div className="header">Your Data as % of Estimate</div>
      }
      {step.showPercentOfSedsStatus === true &&
        <div className="header">Status</div>
      }
      {(step.showAllFuels === true
        || step.currentFuelName === holder.NaturalGas.name)
        &&
        <Assessment1MainTableRow rowClass={state.getGridRowClass(step.showAllFuels, holder.NaturalGas.name)} fieldChangeHandler={fieldChangeHandler} step={step} state={state} fuel={holder.NaturalGas} />
      }
      {(step.showAllFuels === true
        || step.currentFuelName === holder.FuelOil.name)
        &&
        <Assessment1MainTableRow rowClass={state.getGridRowClass(step.showAllFuels, holder.FuelOil.name)} fieldChangeHandler={fieldChangeHandler} step={step} state={state} fuel={holder.FuelOil} />
      }
      {(step.showAllFuels === true
        || step.currentFuelName === holder.Propane.name)
        &&
        <Assessment1MainTableRow rowClass={state.getGridRowClass(step.showAllFuels, holder.Propane.name)} fieldChangeHandler={fieldChangeHandler} step={step} state={state} fuel={holder.Propane} />
      }
    </div>
  </div>
);

export default Assessment1MainTable;
